import axios from "axios";

// Create an Axios instance
const axiosInstance = axios.create({
  baseURL: "", // Replace with your API's base URL
  timeout: 30000, // Set a timeout (optional)
  headers: {
    "Content-Type": "application/json",

    // Add any other custom headers you need
  },
});

// You can also set interceptors for request/response here
axiosInstance.interceptors.request.use(
  (config) => {
    // adding common headers to request headers
    const token = localStorage.getItem("token");
    const mobile = localStorage.getItem("mobile");

    // config.hasOwnProperty("commonHeaderNotRequired")
    if (!("commonHeaderNotRequired" in config) && token) {
      config.headers["cap_authorization"] = token;
      config.headers["cap_brand"] = process.env.REACT_APP_BRAND;
      config.headers["cap_device_id"] = process.env.REACT_APP_DEVICE_ID;
      config.headers["cap_mobile"] = mobile;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    if (response?.data?.status?.code === 401) {
      // Clear local storage and redirect to login page
      localStorage.clear();
      window.location.href = "#/login";
    }
    return response;
  },
  (error) => {
    // Handle errors, like showing a notification or redirecting
    console.error("API call failed", error);

    return Promise.reject(error.response);
  }
);

export default axiosInstance;
